// extracted by mini-css-extract-plugin
module.exports = {"cookie":"src-components-Cookie-styles___cookie","cookieClosed":"src-components-Cookie-styles___cookieClosed","contentContainer":"src-components-Cookie-styles___contentContainer"};